const NO_TYPE_ID = '';
export { NO_TYPE_ID };
